import { render } from "./inspect.vue?vue&type=template&id=c865f3a4&scoped=true"
import script from "./inspect.vue?vue&type=script&lang=js"
export * from "./inspect.vue?vue&type=script&lang=js"

import "./inspect.vue?vue&type=style&index=0&id=c865f3a4&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c865f3a4"]])

export default __exports__